import { t } from "@lingui/macro";

export const ContactPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Contact`}</h1>
  </main>
);
